import React, { useMemo } from 'react';
import { CMBS_ID } from '@/finsight/application/actions/deals/constants';
import DealDetails from './DealDetails';
import TrancheTable from './Tranches/TrancheTable';
import IDeal from '@/finsight/domain/vo/IDeal';
import IRatingsMapping from '@/finsight/domain/vo/IRatingsMapping';
import { getSortedTranches } from '@/finsight/ui/components/deals/helpers';

interface IDealBodyProps {
  deal: IDeal,
  showDealDetailsByDefault: boolean,
  ratingsMapping: IRatingsMapping,
}

const DealBody = ({
  deal,
  showDealDetailsByDefault,
  ratingsMapping,
}: IDealBodyProps) => {
  const isDealCmbs = deal.sector && deal.sector.id === CMBS_ID;
  const dealProductId = deal.product.id;

  const sortedTranches = useMemo(
    () => getSortedTranches(deal.tranches),
    [deal.tranches],
  );

  return (
    <>
      { sortedTranches.length > 0 && (
        <TrancheTable
          dealType={ deal.dealType }
          tranches={ sortedTranches }
          isDealCmbs={ isDealCmbs }
          dealProductId={ dealProductId }
          ratingsMapping={ ratingsMapping }
        />
      ) }

      <DealDetails
        deal={ deal }
        showDealDetailsByDefault={ showDealDetailsByDefault }
      />
    </>
  );
};

export default React.memo(DealBody);
